import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ICarouselImage } from 'src/app/interfaces/carousel-image';
import { Subscription as RxSubscription } from 'rxjs';

import { CarouselImageDataSource } from '../../services/carousel-image-data-source';
import { CarouselImagesAdd } from '../add/component';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { ImagesService } from 'src/app/services/images.service';

@Component({
    selector: 'carousel-image-list-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class CarouselImagesList implements OnInit, OnDestroy {
  public loading: boolean;
  public displayedColumns = ['image', 'title', 'actions'];
  private Subscriptions: RxSubscription[] = [];
  private role;

  constructor(
    private dialog: MatDialog,
    protected dialogRef: MatDialogRef<CarouselImagesList>,
    private commonFunctionService: CommonFunctionService,
    @Inject(MAT_DIALOG_DATA) public DataSource: CarouselImageDataSource,
    private imagesService: ImagesService
  ) {}

  public imageUrl: string = '';
  ngOnInit() {
    this.Subscriptions.push(
      this.DataSource.loading.subscribe(
        (loading: boolean) => (this.loading = loading)
      )
    );
    this.role = this.DataSource.getConfig().role;
    const url = this.commonFunctionService.findApiUrl(this.role);
    this.imageUrl = `${url}/${this.role}/`;
    this.DataSource.load();
  }

  public addImage() {
    const config = new MatDialogConfig();

    config.data = {
      role: this.role,
      organisationId: this.DataSource.getConfig().organisationId,
      Carousel: this.DataSource.connect().getValue(),
    };

    this.Subscriptions.push(
      this.dialog
        .open(CarouselImagesAdd, config)
        .afterClosed()
        .subscribe((CarouselImage: ICarouselImage) => {
          !!CarouselImage && this.DataSource.save(CarouselImage);
        })
    );
  }

  public setFeatured(CarouselImage: ICarouselImage) {
    this.DataSource.setFeatured(CarouselImage);
  }

  public deleteItem(CarouselImage: ICarouselImage) {
    confirm('Are you sure you want to delete: ' + CarouselImage.title) &&
      this.DataSource.delete(CarouselImage);
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }

  public getImageUrl(image, isThumbnail: boolean = false) {
    return this.imagesService.getImageUrl(image, isThumbnail);
  }
}
